import {forwardRef} from "react";
import {t} from "i18next";
import {generateUUID2, getImagePathWithTheme, imgPathPerfix, isStringNullOrEmpty} from "@/utils";
import {Tooltip} from "antd";
import {ipcSend} from "@/common/ipc";

const DesktopProItem = forwardRef((props:{priceItem:any,onButtonClicked:any}, ref) => {
    return(
        <div style={{display:'flex',flexDirection:'column',padding:'26px',margin:'0 16px',height:'100%',position:'relative',
            flexShrink:'0',flexGrow:'1',flexBasis:'0', background:'#FFFFFF',borderRadius:'12px',border:'1px solid #E4E4E4',textWrap:'wrap'}}>
            <span className={'font-family-semi-bold'} style={{fontSize:'22px'}}>{props.priceItem.title}</span>
            <div>
                <span className={'font-family-semi-bold'} style={{fontSize: '40px'}}>${props.priceItem.price}</span>
                {
                    props.priceItem.originPrice &&
                    <span className={'ml-4'} style={{
                        fontSize: '20px',
                        color: '#B0B0B0',
                        textDecoration: 'line-through'
                    }}>${props.priceItem.originPrice}</span>
                }

            </div>

            <span style={{color: '#666666', height: '34px'}}>{props.priceItem.subTitle}</span>
            <div className={'button-solid-style flex-center font-family-semi-bold'} style={{background:'#4B69FF',marginTop:'22px',height:'40px',color:'#ffffff',fontSize:'14px'}} onClick={()=>{
                if (props.onButtonClicked) {
                    props.onButtonClicked(props.priceItem);
                }
            }}>{props.priceItem.buttonText}</div>
            <span className={'font-family-medium'} style={{margin:'16px 0 8px 0'}}>{props.priceItem.infoTitle}</span>
            {
                props.priceItem.subInfo.map(p=>{
                    return(
                        <div key={generateUUID2()} className={'flex-row-vertical-center'} style={{margin:'5px 0'}}>
                            <img style={{width:'16px',height:'12px'}} src={imgPathPerfix()+'checked_green.png'}/>
                            <span style={{color:'#666666',marginLeft:'8px'}} dangerouslySetInnerHTML={{__html:p.title}}></span>
                            {
                                !isStringNullOrEmpty(p.tips) &&
                                <Tooltip overlayStyle={{minWidth:'360px'}} title={<div style={{whiteSpace:'pre',textWrap:'wrap'}}>{p.tips}</div>} placement={"right"}>
                                    <img className={'img-14 ml-6 cursor-pointer'}
                                         src={imgPathPerfix()+'desktop_pro_tip.png'}/>
                                </Tooltip>
                            }
                        </div>
                    )
                })
            }

            {
                props.priceItem.price != 0 &&
                <div style={{
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    background: '#FF8E3F',
                    fontSize: '13px',
                    padding: '1px 6px',
                    display: 'block',
                    borderRadius: '0 8px',
                    color: "white"
                }}>{t("Early bird discount")}</div>
            }

        </div>
    )
})


export default DesktopProItem;


























